var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FieldSwitch',{ref:"switch",attrs:{"model":_vm.$i18n.locale,"title_1":_vm.languages[0].toUpperCase(),"title_2":_vm.languages[1].toUpperCase(),"value_1":_vm.languages[0],"value_2":_vm.languages[1]},on:{"change":_vm.handleLocaleChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }